import EDC from '../../../shared/globals';

EDC.Games.MatchingChests.Clocks.Analog = function (scene, index) {
  this.scene = scene;
  this.cursorManager = scene.cursorManager;
  this.bg = null;
  this.hourHand = null;
  this.minuteHand = null;
  this.bgIndex = index;
  this.HOUR_ANGLE = 360 / 12;
  this.MINUTE_ANGLE = 360 / 60;
  this.MINUTE_HOUR_ANGLE = 90 / 3 / 60;
  this.time = {
    hours: null,
    minutes: null,
  };
  this.container;
};

EDC.Games.MatchingChests.Clocks.Analog.prototype.create = function () {
  this.container = this.scene.add.container(0, 0);
  this.bg = this.scene.add.sprite(0, 0, `clock-analog-bg-${this.bgIndex}`);
  this.container.add(this.bg);

  const key = this.scene.add.sprite(0, this.bg.height / 2, `clock-analog-key-${this.bgIndex}`);
  this.container.add(key);

  this.hourHand = this.scene.add.sprite(0, 0, 'clock-analog-hand-hour');
  this.container.add(this.hourHand);

  this.minuteHand = this.scene.add.sprite(0, 0, 'clock-analog-hand-minute');
  this.container.add(this.minuteHand);

  this.container.setSize(this.bg.width, this.bg.height);
  this.container.setInteractive();
  this.scene.input.setDraggable(this.container);

  this.cursorManager.setDefaultDraggableEvents(this.container);

  this.container.on(
    'drag',
    function (pointer, dragX, dragY) {
      this.container.x = dragX;
      this.container.y = dragY;
    },
    this,
  );

  this.container.on('dragend', this.dragStop, this);
};

EDC.Games.MatchingChests.Clocks.Analog.prototype.destroyAnalog = function () {
  this.bg.destroy();
  this.container.destroy();
};

EDC.Games.MatchingChests.Clocks.Analog.prototype.place = function (x, y) {
  this.container.setPosition(x, y);
  this.container.setData('originX', x);
  this.container.setData('originY', y);
};

EDC.Games.MatchingChests.Clocks.Analog.prototype.dragStop = function (target) {
  this.scene.clockDropped(this);
};

EDC.Games.MatchingChests.Clocks.Analog.prototype.setTime = function (hours, minutes) {
  this.hourHand.angle = hours * this.HOUR_ANGLE + this.MINUTE_HOUR_ANGLE * minutes;
  this.minuteHand.angle = minutes * this.MINUTE_ANGLE;

  this.time.hours = hours;
  this.time.minutes = minutes;
};

EDC.Games.MatchingChests.Clocks.Analog.prototype.moveBack = function () {
  this.cursorManager.resetCursor();
  this.scene.tweens.add({
    targets: this.container,
    x: this.container.getData('originX'),
    y: this.container.getData('originY'),
    duration: 150,
    ease: 'Sine.InOut',
  });
};

EDC.Games.MatchingChests.Clocks.Analog.prototype.hide = function () {
  this.scene.tweens.add({
    targets: this.container,
    alpha: 0,
    duration: 500,
    ease: 'Linear',
  });
};

export default EDC.Games.MatchingChests.Clocks.Analog;
